module.exports = __webpack_public_path__ + "img/co_bg4.b5c01b11.png";